import React, { useEffect } from "react";

let globalLoaded = false;
function loadPlayerScript() {
  if (globalLoaded || typeof document === "undefined") return;
  if (document.querySelector('script[src="https://fast.wistia.com/player.js"]')) {
    globalLoaded = true;
    return;
  }
  const s = document.createElement("script");
  s.src = "https://fast.wistia.com/player.js";
  s.async = true;
  document.head.appendChild(s);
  globalLoaded = true;
}

/**
 * Wistia <wistia-player> custom-element wrapper.
 * - Loads the global player.js once per page
 * - Loads the media-specific embed module per video
 * - Shows a blurred swatch placeholder until the player is defined
 */
const WistiaPlayer = ({
  mediaId,
  aspect = 1.7777777777777777,
  className = "",
  autoplay = false,
  loop = false,
  muted = false,
}) => {
  useEffect(() => {
    loadPlayerScript();
    const id = `wistia-embed-${mediaId}`;
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.src = `https://fast.wistia.com/embed/${mediaId}.js`;
      s.async = true;
      s.type = "module";
      document.head.appendChild(s);
    }
  }, [mediaId]);

  const attrs = {
    "media-id": mediaId,
    aspect: String(aspect),
    style: { display: "block", width: "100%" },
  };
  if (autoplay) attrs.autoplay = "true";
  if (loop) attrs.loop = "true";
  if (muted) attrs.muted = "true";

  return (
    <div className={`wistia-wrap relative w-full ${className}`} data-testid={`wistia-${mediaId}`}>
      <style>{`wistia-player[media-id='${mediaId}']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${mediaId}/swatch'); display: block; filter: blur(5px); padding-top:${100 / aspect}%; }`}</style>
      {React.createElement("wistia-player", attrs)}
    </div>
  );
};

export default WistiaPlayer;
